import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Typography,
  Space,
  Row,
  Col,
  message,
  Divider,
} from 'antd';
import axios from 'axios';
import { baseUrl } from '../../common/constants';
import _axios from '../../utils/api/_axios';
import { Content } from 'antd/es/layout/layout';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';

const { Title } = Typography;
const { Option } = Select;

const CreateUser = ({
  onSubmit,
  handleClose,
  parentId = null,
  currentUserId = null,
  isEdit = false,
  isEditModalOpen = false,
  isEditingAdjuster = false,
  userRoles,
  open,
  user = "User",
  create = "Create",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [roles, setRoles] = useState([]);
  let index = 0;
  let serviceIndex = 0
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isEditCat, setIsEditCat] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const inputRef = useRef(null);

  const [serviceItems, setServiceItems] = useState([]);
  const [serviceName, setServiceName] = useState('');
  const [selectedServices, setSelectedServices] = useState([]);
  const [isEditService, setIsEditService] = useState(false)
  const [selectedServiceId, setSelectedServiceId] = useState('')
  const serviceInputRef = useRef(null);

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSelectChange = (value) => {
    const selectedItems = items
      .filter(item => value?.includes(item?._id))
      .map(item => ({ id: item?._id, name: item?.name }));

    setSelectedCategories(selectedItems);
  };


  const handleSelectServiceChange = (value) => {
    const selectedNames = serviceItems
      .filter(item => value.includes(item?._id))
      .map(item =>  ({ id: item?._id, name: item?.name }));

    setSelectedServices(selectedNames);

  };


  const addItem = async (e) => {
    e.preventDefault();

    const newItem = name || `New item ${index++}`;
    try {
      const response = await _axios.post(`${baseUrl}/categories`, { name: newItem });

      if (response.status === 201) {
        const addedItem = response.data;
        setItems(prevItems => [...prevItems, addedItem]);
        setName('');
        setTimeout(() => {
          inputRef.current?.focus();
        }, 0);
        fetchCategories();
      }
    } catch (error) {
      console.error('Error adding item:', error);
    }
  };

  const addServicesItem = async (e) => {
    e.preventDefault();

    const newItem = serviceName || `New item ${index++}`;
    try {
      const response = await _axios.post(`${baseUrl}/services`, { name: newItem });

      if (response.status === 201) {
        const addedItem = response.data;
        setServiceItems(prevItems => [...prevItems, addedItem]);
        setServiceName('');
        setTimeout(() => {
          serviceInputRef.current?.focus();
        }, 0);
        fetchServices();
      }
    } catch (error) {
      console.error('Error adding item:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await _axios.get(`${baseUrl}/categories`);
      const categories = response.data;
      setItems(categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchServices = async () => {
    try {
      const response = await _axios.get(`${baseUrl}/services`);
      const categories = response.data;
      setServiceItems(categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await _axios.get(`${baseUrl}/users/${currentUserId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const userData = response.data.payload;
      console.log("userData", userData);

      const selectedCategoryIds = userData.categories || [];
      const selectedServiceIds = userData.services || [];

      setSelectedCategories(selectedCategoryIds);
      setSelectedServices(selectedServiceIds);

      form.setFieldsValue({
        mobile: userData.mobile,
        email: userData.personal?.email,
        firstName: userData.personal?.firstName,
        lastName: userData.personal?.lastName,
        phoneNumber: userData.personal?.phoneNumber,
        addressLine1: userData.personal?.address?.addressLine1,
        addressLine2: userData.personal?.address?.addressLine2,
        city: userData.personal?.address?.city,
        state: userData.personal?.address?.state,
        zip: userData.personal?.address?.zip,
        roles: userData.roles,
        isActive: userData.isActive,
      });
      setRoles(userData.roles);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      const body = {
        mobile: values.mobile,
        parentId: parentId,
        personal: {
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          address: {
            addressLine1: values.addressLine1,
            addressLine2: values.addressLine2,
            city: values.city,
            state: values.state,
            zip: values.zip,
          },
        },
        categories: selectedCategories,
        password: values.password,
        roles: user === "Doctor" ? [1] : roles,
      };

      if (isEditing) {
        await _axios.put(`${baseUrl}/users/${currentUserId}`, body);
        message.success('User updated successfully.');
        window.location.reload()
      } else {
        const response = await _axios.post(`${baseUrl}/authentication/signup`, body);
        if (response.status === 200 || response.status === 201) {
          if (onSubmit) {
            onSubmit(body);
          }
          window.location.reload();
          message.success('User created successfully.');
        }
      }

      form.resetFields();
      if (handleClose) {
        handleClose();
      }
    } catch (error) {
      message.error('Error creating user');
      console.error('Error creating user:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchServices();
    if (isEditingAdjuster) {
      setIsEditing(true);
      fetchUserData();
    }
  }, [parentId, currentUserId]);

  const handleRolesChange = (selectedRoles) => {
    setRoles(selectedRoles);
  };

  const editItem = async (id, name) => {
    setIsEditCat(true)
    setName(name)
  };

  const deleteItem = async (id) => {
    try {
      await _axios.delete(`${baseUrl}/categories/remove/${id}`);
      fetchCategories()
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  };



  const updateCategories = async () => {
    try {
      const response = await _axios.put(`${baseUrl}/categories/update/${selectedId}`, { name: name });
      fetchCategories()
      if (response.status == 200) {
        toast.success("Category updated")
        setName("")
        setIsEditCat(false)
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  }

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    if (phoneNumber.length < 4) return phoneNumber;
    if (phoneNumber.length < 7) return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const phoneNumberValidator = (_, value) => {
    if (!value) return Promise.resolve();
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(value)) {
      return Promise.reject('Please enter phone number in format: xxx-xxx-xxxx');
    }
    return Promise.resolve();
  };

  return (
    <div style={{ padding: '20px', marginTop: '1vh', maxWidth: '600px', margin: 'auto' }}>
      <Title level={3}>
        {create} {user}
      </Title>
      <Content>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item 
                label="Mobile" 
                name="mobile" 
                rules={[
                  { required: true, message: 'Please enter mobile number' },
                  { validator: phoneNumberValidator }
                ]}
                normalize={formatPhoneNumber}
              >
                <Input maxLength={12} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Please enter email' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="First Name" name="firstName" rules={[{ required: true, message: 'Please enter first name' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Last Name" name="lastName" rules={[{ required: true, message: 'Please enter last name' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label="Phone Number" 
                name="phoneNumber"
                rules={[{ validator: phoneNumberValidator }]}
                normalize={formatPhoneNumber}
              >
                <Input maxLength={12} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Address Line 1" name="addressLine1">
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Address Line 2" name="addressLine2">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="City" name="city">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="State" name="state">
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="ZIP Code" name="zip">
                <Input />
              </Form.Item>
            </Col>
            {user !== "Doctor" && (
              <Col span={24}>
                <Form.Item label="Roles">
                  <Select
                    mode="multiple"
                    value={roles}
                    onChange={handleRolesChange}
                    style={{ width: '100%' }}
                  >
                    {user === "Doctor" && <Option value={1}>DOCTOR</Option>}
                    {user === "Adjuster" && <Option value={4}>ADJUSTER</Option>}
                    {/* Add more roles as needed */}
                  </Select>
                </Form.Item>
              </Col>
            )}
            {(user === "Adjuster" && !parentId) && (
              <Col span={24}>
                <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please enter password' }]}>
                  <Input.Password />
                </Form.Item>
              </Col>
            )}

            <Col span={24}>
              {user === "Doctor" && (
                <Form.Item label="Categories">
                  <Select
                    mode="multiple"
                    onChange={handleSelectChange}
                    value={selectedCategories.map(item => item.id)} // Map to get the IDs
                    placeholder="Custom dropdown render"
                    dropdownRender={menu => (
                      <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Space style={{ padding: '0 8px 4px' }}>
                          <Input
                            placeholder="Please enter item"
                            ref={inputRef}
                            value={name}
                            onChange={onNameChange}
                            onKeyDown={e => e.stopPropagation()}
                          />
                          {
                            isEditCat ?
                              <Button type="text" onClick={updateCategories}>
                                Update
                              </Button>
                              :
                              <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                Add Category
                              </Button>
                          }
                        </Space>
                      </>
                    )}
                    options={items.map(item => ({
                      label: (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{item.name}</span>
                          <span>
                            <EditOutlined
                              onClick={() => {
                                editItem(item._id, item?.name);
                                setSelectedId(item?._id);
                              }}
                              style={{ marginRight: 8 }}
                            />
                            <DeleteOutlined onClick={() => deleteItem(item._id)} />
                          </span>
                        </div>
                      ),
                      value: item?._id,
                    }))}
                  />
                </Form.Item>
              )}
            </Col>
            <Col span={24}>
              <Space>
                <Button type="primary" htmlType="submit">
                  {create} {user}
                </Button>
                {handleClose && (
                  <Button onClick={handleClose}>
                    Close
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
        </Form>
      </Content>
    </div>
  );
};

export default CreateUser;
